import clsx from 'clsx'
import React, {useContext} from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import {TeacherContext} from 'teacher/context'

import EditQuestion from './edit-question'
import NewQuestion from './new-question'
import Question from './question'

const useStyles = makeStyles(questionsStyles)

export default function Questions() {

  const classes = useStyles()
  const context = useContext(TeacherContext)
  const {quizQuestionBank: questions, quizNewBankQuestion: question, sectionName, questionId} = context

  return (
    <Box className={classes.root} >
      <EditQuestion open={sectionName == 'edit-question'} />
      <NewQuestion open={sectionName == 'new-question' && question.id != undefined} />
      {questions.map((question, index) => (<Question key={index} {...question} />))}
    </Box>
  )
}

function questionsStyles() {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      width: '100%',
    },
  }
}

